<template>
    <div>
        <div v-if="loading" class="loading-overlay">
            <div class="loading-content">
                <div class="spinner-border text-primary" role="status"></div>

                <div class="mt-3">Mohon tunggu...</div>
            </div>
        </div>

        <div class="p-3">
            <div class="d-flex justify-content-between align-items-center mb-3">
                <h3 class="mb-0">Update Regno</h3>

                <button
                    type="button"
                    class="btn btn-secondary"
                    :disabled="loading"
                    @click="openHistory"
                >
                    <i class="fa fa-history"></i>
                    History Update
                </button>
            </div>

            <hr />

            <div class="card mb-3">
                <div class="card-header bg-primary text-white">
                    Pencarian Pasien
                </div>

                <div class="card-body">
                    <div class="row">
                        <div class="col-md-4">
                            <label>Medrec / Nama</label>

                            <input
                                v-model="filter.search"
                                type="text"
                                class="form-control"
                                @keyup.enter="getAllPasien"
                            />
                        </div>

                        <div class="col-md-2 d-flex align-items-end">
                            <button
                                type="button"
                                class="btn btn-primary"
                                :disabled="loading"
                                @click="getAllPasien"
                            >
                                Cari
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div class="card">
                <div class="card-header bg-primary text-white">Data Pasien</div>

                <div class="card-body">
                    <div id="table-regno"></div>
                </div>
            </div>

            <div id="modal-detail" class="modal fade" tabindex="-1">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Detail Regno</h5>

                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                            ></button>
                        </div>

                        <div class="modal-body">
                            <div class="row mb-3">
                                <div class="col-md-4">
                                    <input
                                        v-model="detail_search"
                                        type="text"
                                        class="form-control"
                                        placeholder="Cari Regno..."
                                        @input="filterRegno"
                                    />
                                </div>
                            </div>

                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Regno</th>
                                            <th>Tanggal</th>
                                            <th>Total Data</th>
                                            <th width="280">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr
                                            v-for="item in detail_regno_filtered"
                                            :key="item.Regno"
                                        >
                                            <td>{{ item.Regno }}</td>
                                            <td>{{ item.Regdate }}</td>
                                            <td>{{ item.total_data }}</td>

                                            <td>
                                                <button
                                                    type="button"
                                                    class="btn btn-warning btn-sm me-2"
                                                    :disabled="loading"
                                                    @click="openUpdate(item)"
                                                >
                                                    Merge Regno
                                                </button>

                                                <button
                                                    type="button"
                                                    class="btn btn-info btn-sm text-white"
                                                    :disabled="loading"
                                                    @click="
                                                        openUpdateOnly(item)
                                                    "
                                                >
                                                    Ganti Regno Saja
                                                </button>
                                            </td>
                                        </tr>

                                        <tr
                                            v-if="
                                                detail_regno_filtered.length ===
                                                0
                                            "
                                        >
                                            <td colspan="4" class="text-center">
                                                Data tidak ditemukan
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modal-update" class="modal fade" tabindex="-1">
                <div class="modal-dialog modal-lg">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Merge Regno</h5>

                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                            ></button>
                        </div>

                        <div class="modal-body">
                            <div class="mb-3">
                                <label>Regno Lama</label>

                                <input
                                    v-model="form.old_regno"
                                    type="text"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="mb-3">
                                <label>Regno Tujuan</label>

                                <div class="mb-2">
                                    <input
                                        v-model="regno_option_search"
                                        type="text"
                                        class="form-control"
                                        placeholder="Cari Regno Tujuan..."
                                        @input="filterRegnoOption"
                                    />
                                </div>

                                <select
                                    v-model="form.new_regno"
                                    class="form-control"
                                    size="8"
                                >
                                    <option value="">Pilih Regno</option>

                                    <option
                                        v-for="item in regno_options_filtered"
                                        :key="item.Regno"
                                        :value="item.Regno"
                                        :disabled="
                                            item.Regno === form.old_regno
                                        "
                                    >
                                        {{ item.Regno }}
                                    </option>
                                </select>
                            </div>

                            <hr />

                            <div class="alert alert-warning">
                                Seluruh data pada tabel berikut akan dipindahkan
                                ke Regno tujuan.
                            </div>

                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Tabel</th>
                                            <th>Jumlah Data</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr
                                            v-for="item in preview_data"
                                            :key="item.table"
                                        >
                                            <td>{{ item.table }}</td>
                                            <td>{{ item.count }}</td>
                                        </tr>

                                        <tr v-if="preview_data.length === 0">
                                            <td colspan="2" class="text-center">
                                                Tidak ada data
                                            </td>
                                        </tr>
                                    </tbody>

                                    <tfoot>
                                        <tr>
                                            <th>Total</th>
                                            <th>{{ grand_total }}</th>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Batal
                            </button>

                            <button
                                type="button"
                                class="btn btn-primary"
                                :disabled="loading"
                                @click="saveUpdate"
                            >
                                Merge Regno
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modal-update-only" class="modal fade" tabindex="-1">
                <div class="modal-dialog">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">Ganti Nomor Regno Saja</h5>

                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                            ></button>
                        </div>

                        <div class="modal-body">
                            <div class="alert alert-info">
                                Hanya kolom Regno pada tabel Register yang akan
                                diubah. Tabel lainnya tidak akan diperbarui.
                            </div>

                            <div class="mb-3">
                                <label>Regno Lama</label>

                                <input
                                    v-model="form_only.old_regno"
                                    type="text"
                                    class="form-control"
                                    readonly
                                />
                            </div>

                            <div class="mb-3">
                                <label>Regno Baru</label>

                                <input
                                    v-model.trim="form_only.new_regno"
                                    type="text"
                                    class="form-control"
                                    placeholder="Masukkan Regno baru"
                                    @keyup.enter="saveUpdateOnly"
                                />
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button
                                type="button"
                                class="btn btn-secondary"
                                data-bs-dismiss="modal"
                            >
                                Batal
                            </button>

                            <button
                                type="button"
                                class="btn btn-info text-white"
                                :disabled="loading"
                                @click="saveUpdateOnly"
                            >
                                Ganti Regno
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            <div id="modal-history" class="modal fade" tabindex="-1">
                <div class="modal-dialog modal-xl">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title">History Update Regno</h5>

                            <button
                                type="button"
                                class="btn-close"
                                data-bs-dismiss="modal"
                            ></button>
                        </div>

                        <div class="modal-body">
                            <div class="table-responsive">
                                <table class="table table-bordered">
                                    <thead>
                                        <tr>
                                            <th>Tanggal</th>
                                            <th>Medrec</th>
                                            <th>Regno Lama</th>
                                            <th>Regno Baru</th>
                                            <th>User</th>
                                            <th>Status</th>
                                            <th width="120">Action</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        <tr
                                            v-for="item in history_data"
                                            :key="item.id"
                                        >
                                            <td>{{ item.tanggal_update }}</td>
                                            <td>{{ item.medrec }}</td>
                                            <td>{{ item.old_regno }}</td>
                                            <td>{{ item.new_regno }}</td>
                                            <td>{{ item.nama }}</td>

                                            <td>
                                                <span
                                                    v-if="item.rollback_at"
                                                    class="badge bg-success"
                                                >
                                                    Rollback
                                                </span>

                                                <span
                                                    v-else
                                                    class="badge bg-warning"
                                                >
                                                    Active
                                                </span>
                                            </td>

                                            <td>
                                                <button
                                                    v-if="!item.rollback_at"
                                                    type="button"
                                                    class="btn btn-danger btn-sm"
                                                    :disabled="loading"
                                                    @click="rollback(item)"
                                                >
                                                    Rollback
                                                </button>

                                                <span
                                                    v-else
                                                    class="badge bg-secondary"
                                                >
                                                    Selesai
                                                </span>
                                            </td>
                                        </tr>

                                        <tr v-if="history_data.length === 0">
                                            <td colspan="7" class="text-center">
                                                History belum tersedia
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import * as bootstrap from "bootstrap";
import Swal from "sweetalert2";
import { TabulatorFull as Tabulator } from "tabulator-tables";

export default {
    data() {
        return {
            loading: false,
            table: null,
            selected_medrec: null,
            detail_search: "",
            regno_option_search: "",
            detail_regno: [],
            detail_regno_filtered: [],
            regno_options: [],
            regno_options_filtered: [],
            preview_data: [],
            history_data: [],
            grand_total: 0,
            filter: {
                search: "",
            },
            form: {
                old_regno: "",
                new_regno: "",
            },
            form_only: {
                old_regno: "",
                new_regno: "",
            },
        };
    },

    mounted() {
        this.getAllPasien();
    },

    beforeUnmount() {
        if (this.table) {
            this.table.destroy();
            this.table = null;
        }
    },

    methods: {
        getModal(id) {
            const element = document.getElementById(id);

            if (!element) {
                return null;
            }

            return (
                bootstrap.Modal.getInstance(element) ||
                new bootstrap.Modal(element)
            );
        },

        async getAllPasien() {
            this.loading = true;

            try {
                const element = document.getElementById("table-regno");

                if (this.table) {
                    this.table.destroy();
                    this.table = null;
                }

                this.table = new Tabulator(element, {
                    layout: "fitColumns",
                    responsiveLayout: "collapse",
                    pagination: true,
                    paginationMode: "remote",
                    paginationSize: 10,
                    paginationSizeSelector: [10, 25, 50, 100],
                    ajaxURL: "/api/update-regno/get-all-pasien",
                    ajaxParams: {
                        search: this.filter.search,
                    },
                    ajaxResponse: (url, params, response) => {
                        this.loading = false;
                        return response.data;
                    },
                    ajaxError: async () => {
                        this.loading = false;

                        await Swal.fire({
                            icon: "error",
                            title: "Gagal",
                            text: "Gagal mengambil data pasien",
                        });
                    },
                    columns: [
                        {
                            title: "Medrec",
                            field: "Medrec",
                        },
                        {
                            title: "Nama",
                            field: "Firstname",
                        },
                        {
                            title: "Total Regno",
                            field: "total_regno",
                            hozAlign: "center",
                        },
                        {
                            title: "Action",
                            width: 120,
                            hozAlign: "center",
                            formatter() {
                                return `
                                    <button class="btn btn-primary btn-sm">
                                        Detail
                                    </button>
                                `;
                            },
                            cellClick: (event, cell) => {
                                this.openDetail(cell.getRow().getData());
                            },
                        },
                    ],
                });
            } catch (error) {
                this.loading = false;

                await Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text:
                        error?.response?.data?.message ||
                        "Gagal mengambil data pasien",
                });
            }
        },

        async openDetail(data) {
            this.loading = true;

            try {
                this.selected_medrec = data.Medrec;

                const result = await axios.get(
                    "/api/update-regno/get-detail-regno",
                    {
                        params: {
                            medrec: data.Medrec,
                        },
                    }
                );

                this.detail_regno = result.data.data || [];
                this.detail_regno_filtered = [...this.detail_regno];
                this.regno_options = [...this.detail_regno];
                this.regno_options_filtered = [...this.detail_regno];
                this.detail_search = "";
                this.regno_option_search = "";

                this.loading = false;
                this.getModal("modal-detail")?.show();
            } catch (error) {
                this.loading = false;

                await Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text:
                        error?.response?.data?.message ||
                        "Gagal mengambil detail Regno",
                });
            }
        },

        async reloadDetail() {
            if (!this.selected_medrec) {
                return;
            }

            const result = await axios.get(
                "/api/update-regno/get-detail-regno",
                {
                    params: {
                        medrec: this.selected_medrec,
                    },
                }
            );

            this.detail_regno = result.data.data || [];
            this.detail_regno_filtered = [...this.detail_regno];
            this.regno_options = [...this.detail_regno];
            this.regno_options_filtered = [...this.detail_regno];
        },

        async openUpdate(item) {
            this.loading = true;

            try {
                this.form.old_regno = item.Regno;
                this.form.new_regno = "";
                this.regno_option_search = "";

                this.regno_options_filtered = this.regno_options.filter(
                    (option) => {
                        return option.Regno !== item.Regno;
                    }
                );

                const result = await axios.get(
                    "/api/update-regno/get-preview-update",
                    {
                        params: {
                            regno: item.Regno,
                        },
                    }
                );

                this.preview_data = result.data.data || [];
                this.grand_total = result.data.grand_total || 0;

                this.loading = false;
                this.getModal("modal-update")?.show();
            } catch (error) {
                this.loading = false;

                await Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text:
                        error?.response?.data?.message ||
                        "Gagal mengambil preview data",
                });
            }
        },

        openUpdateOnly(item) {
            this.form_only.old_regno = item.Regno;
            this.form_only.new_regno = "";

            this.getModal("modal-update-only")?.show();
        },

        async saveUpdate() {
            if (!this.form.new_regno) {
                await Swal.fire({
                    icon: "warning",
                    title: "Peringatan",
                    text: "Pilih Regno tujuan terlebih dahulu",
                });

                return;
            }

            if (this.form.old_regno === this.form.new_regno) {
                await Swal.fire({
                    icon: "warning",
                    title: "Peringatan",
                    text: "Regno tujuan tidak boleh sama",
                });

                return;
            }

            const confirmation = await Swal.fire({
                title: "Konfirmasi Merge",
                html: `
                    <div style="text-align:left">
                        <b>Regno Lama:</b>
                        ${this.form.old_regno}
                        <br>
                        <b>Regno Tujuan:</b>
                        ${this.form.new_regno}
                        <br><br>
                        Seluruh data transaksi akan dipindahkan
                        ke Regno tujuan.
                    </div>
                `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ya, Merge",
                cancelButtonText: "Batal",
            });

            if (!confirmation.isConfirmed) {
                return;
            }

            await this.processUpdate();
        },

        async processUpdate() {
            this.loading = true;

            try {
                const result = await axios.post(
                    "/api/update-regno/update-regno",
                    this.form
                );

                if (result.data.status !== "success") {
                    throw new Error(
                        result.data.message || "Merge Regno gagal dilakukan"
                    );
                }

                this.getModal("modal-update")?.hide();
                this.getModal("modal-detail")?.hide();

                this.loading = false;

                await Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                    text:
                        result.data.message || "Merge Regno berhasil dilakukan",
                });

                await this.getAllPasien();
            } catch (error) {
                this.loading = false;

                await Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text:
                        error?.response?.data?.message ||
                        error.message ||
                        "Terjadi kesalahan",
                });
            }
        },

        async saveUpdateOnly() {
            const oldRegno = String(this.form_only.old_regno || "").trim();

            const newRegno = String(this.form_only.new_regno || "").trim();

            if (!newRegno) {
                await Swal.fire({
                    icon: "warning",
                    title: "Peringatan",
                    text: "Regno baru wajib diisi",
                });

                return;
            }

            if (oldRegno === newRegno) {
                await Swal.fire({
                    icon: "warning",
                    title: "Peringatan",
                    text: "Regno baru tidak boleh sama",
                });

                return;
            }

            const confirmation = await Swal.fire({
                title: "Ganti Regno?",
                html: `
                    <div style="text-align:left">
                        <b>Regno Lama:</b>
                        ${oldRegno}
                        <br>
                        <b>Regno Baru:</b>
                        ${newRegno}
                        <br><br>
                        Hanya nomor Regno pada tabel Register
                        yang akan diubah. Tabel lainnya tidak
                        akan diperbarui.
                    </div>
                `,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ya, Ganti",
                cancelButtonText: "Batal",
            });

            if (!confirmation.isConfirmed) {
                return;
            }

            this.loading = true;

            try {
                const result = await axios.post(
                    "/api/update-regno/update-regno-only",
                    {
                        old_regno: oldRegno,
                        new_regno: newRegno,
                    }
                );

                if (result.data.status !== "success") {
                    throw new Error(
                        result.data.message || "Regno gagal diganti"
                    );
                }

                this.getModal("modal-update-only")?.hide();

                this.loading = false;

                await Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                    text: result.data.message || "Nomor Regno berhasil diganti",
                });

                this.loading = true;

                await this.reloadDetail();

                this.loading = false;

                await this.getAllPasien();
            } catch (error) {
                this.loading = false;

                await Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text:
                        error?.response?.data?.message ||
                        error.message ||
                        "Regno gagal diganti",
                });
            }
        },

        filterRegnoOption() {
            const keyword = String(
                this.regno_option_search || ""
            ).toLowerCase();

            this.regno_options_filtered = this.regno_options.filter((item) => {
                return (
                    item.Regno !== this.form.old_regno &&
                    String(item.Regno).toLowerCase().includes(keyword)
                );
            });
        },

        filterRegno() {
            const keyword = String(this.detail_search || "").toLowerCase();

            this.detail_regno_filtered = this.detail_regno.filter((item) => {
                return String(item.Regno).toLowerCase().includes(keyword);
            });
        },

        async openHistory() {
            this.loading = true;

            try {
                const result = await axios.get("/api/update-regno/history");

                this.history_data = result.data.data?.data || [];

                this.loading = false;
                this.getModal("modal-history")?.show();
            } catch (error) {
                this.loading = false;

                await Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text:
                        error?.response?.data?.message ||
                        "Gagal mengambil history",
                });
            }
        },

        async rollback(item) {
            const confirmation = await Swal.fire({
                title: "Rollback?",
                text: `Kembalikan Regno ${item.new_regno} ke ${item.old_regno}?`,
                icon: "warning",
                showCancelButton: true,
                confirmButtonText: "Ya, Rollback",
                cancelButtonText: "Batal",
            });

            if (!confirmation.isConfirmed) {
                return;
            }

            this.loading = true;

            try {
                const result = await axios.post("/api/update-regno/rollback", {
                    log_id: item.id,
                });

                if (result.data.status !== "success") {
                    throw new Error(result.data.message || "Rollback gagal");
                }

                this.loading = false;

                await Swal.fire({
                    icon: "success",
                    title: "Berhasil",
                    text: result.data.message || "Rollback berhasil",
                });

                await this.openHistory();
            } catch (error) {
                this.loading = false;

                await Swal.fire({
                    icon: "error",
                    title: "Gagal",
                    text:
                        error?.response?.data?.message ||
                        error.message ||
                        "Terjadi kesalahan",
                });
            }
        },
    },
};
</script>

<style scoped>
.loading-overlay {
    position: fixed;
    inset: 0;
    z-index: 9998;
    display: flex;
    justify-content: center;
    align-items: center;
    background: rgba(255, 255, 255, 0.75);
}

.loading-content {
    text-align: center;
}

.table td,
.table th {
    vertical-align: middle;
}

:global(.swal2-container) {
    z-index: 100000 !important;
}
</style>
